import { Component } from "@angular/core";
import { provideTranslocoScope } from "@jsverse/transloco";
import { TabModel } from "@models/generic/TabModels/TabModel";

@Component({
    selector: "app-external-connection-overview",
    templateUrl: "./external-connection-overview.component.html",
    styleUrls: ["./external-connection-overview.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope("external-connections")],
})
export class ExternalConnectionOverviewComponent {
    tabID: string;
    tab: TabModel;

    constructor() {}
}
